import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ✅ Route-to-title mapping
const routeTitleMap = {
  // ---------- AUTH ----------
  "/": "Privacy First, Intelligence Always",
  "/forgot-password": "Forgot Password",
  "/verify-email": "Verify Email",
  "/reset-password": "Reset Password",
  "/successful": "Password Reset Successful",
  "/terms": "Terms & Conditions",

  // ---------- USER ----------
  "/user/new": "New Chat",
  "/user/chat": "Chat",
  "/user/chat/document": "Document Chat",
  "/user/newchat": "Start New Chat",
  "/user/imagetotext": "Image to Text",
  "/user/imagetovideo": "Image to Video",
  "/user/audiototext": "Audio to Text",
  "/user/audiotoaudio": "Audio to Audio",
  "/user/audiotochat": "Audio Chat",
  "/user/pdftoall": "PDF Toolkit",
  "/user/activity-log": "Trace Log",
  "/user/notifications": "Notifications",
  "/user/train-docs": "Train Documents",
  "/user/knowledge-repository": "Knowledge Repository - Uploaded Documents",
  "/user/knowledgerepository-weburls":
    "Knowledge Repository - Web URLs History",
  "/user/knowledgerepository-videourls":
    "Knowledge Repository - Video URLs History",
  "/user/knowledgerepository-deletedocs":
    "Knowledge Repository - Delete History",
  "/user/texthistory": "Knowledge Repository - Text History",
  "/user/qahistory": "Knowledge Repository - Q&A History",
  "/user/profile": "Profile Settings",
  "/user/getHelpPage": "Help & Support",
  "/user/pdf-to-all": "PDF Toolkit",
  "/user/training-studio": "Training Studio",
  "/user/knowledgespace-docs": "Personal Storage - Uploaded Documents",
  "/user/personal-space": "My Personal Space - Saved Documents",
  "/user/knowledgespace-deleted": "My Personal Space - Deleted Documents",
  "/user/knowledgespace-recent": "Personal Storage - Recent Documents",
  "/user/terms-usage": "Terms & Usage",
  "/user/repo-organizer":"Repository Organizer",

  // ---------- SUPERADMIN ----------
  "/superadmin/dashboard": "Dashboard",
  "/superadmin/enterprize-management": "Enterprize Management",
  "/superadmin/enterprize-setting": "Enterprize Settings",
  "/superadmin/file-management": "File Management",
  "/superadmin/trace-logs": "Trace Logs",
  "/superadmin/error-logs": "Error Logs",
  "/superadmin/role-management": "Role Management",
  "/superadmin/module": "Module Management",
  "/superadmin/user-management": "User Management",
  "/superadmin/model-dynamic": "Dynamic Model Management",
  "/superadmin/product-management": "Product Management",
  "/superadmin/model-management": "Models Management",
  "/superadmin/version-management": "Version Management",
  "/superadmin/notifications": "Notifications",
  "/superadmin/conversation-management": "Conversation Management",
  "/superadmin/chat-usage-management": "Chat Usage Management",
  "/superadmin/user-session-management": "User Session Management",
  "/superadmin/subscription-management": "Subscription Management",
  "/superadmin/profile": "Profile Settings",
  "/superadmin/getHelpPage": "Help & Support",

  // ---------- ADMIN ----------
  "/admin/dashboard": "Dashboard",
  "/admin/user-managements": "User Management",
  "/admin/enterprise-settings": "Enterprize Settings",
  "/admin/enterprize-managements": "Enterprize Management",
  "/admin/trace-logs": "Trace Logs",
  "/admin/group-management": "Group Management",
  "/admin/training-files": "Training Documents URLs",
  "/admin/training-text": "Training Text",
  "/admin/training-website": "Training Web URLs",
  "/admin/training-qa": "Training Q&A",
  "/admin/training-youtube": "Training Video URLs",
  "/admin/uploaded-docs": "Uploaded Documents",
  "/admin/knowledge-repository": "Knowledge Repository - Document History",
  "/admin/knowledge-repo-urls": "Knowledge Repository - URLs History",
  "/admin/knowledge-repo-text": "Knowledge Repository - Text History",
  "/admin/knowledge-repo-video": "Knowledge Repository - Video URLs History",
  "/admin/knowledge-repo-qa": "Knowledge Repository - Q&A History",
  "/admin/notifications": "Notifications",
  "/admin/profile": "Profile Settings",
  "/admin/conversation-management": "Conversation Management",
  "/admin/chat-usage-management": "Chat Usage Management",
  "/admin/user-session-management": "User Session Management",
  "/admin/getHelpPage": "Help & Support",
  "/admin/repo-organizer": "Repository Organizer",
  "/admin/performance-logs": "Performance Logs",

  // ---------- OTHER ----------
  "/premium-page": "Premium Subscription",
  "/chat/shared": "Shared Chat",
  "/view-conversation": "View Conversation",
  "/getHelpPage": "Help & Support",
};

export default function PageTitleUpdater() {
  const { pathname } = useLocation();

  useEffect(() => {
    let cleanPath = pathname.toLowerCase();

    // ✅ Handle dynamic routes with params
    if (cleanPath.startsWith("/user/new/")) cleanPath = "/user/new";
    else if (cleanPath.startsWith("/chat/shared/")) cleanPath = "/chat/shared";
    else if (cleanPath.startsWith("/view-conversation/"))
      cleanPath = "/view-conversation";

    // ✅ Resolve title or fallback
    const title = routeTitleMap[cleanPath] || "VelaKoda";

    document.title = `VelaKoda | ${title}`;
  }, [pathname]);

  return null;
}
